import { api } from '../api.ts';
import { publicPage, wireChrome } from '../components/chrome.ts';
import { formData, html, mount } from '../html.ts';
import { currentIntlLocale, t } from '../i18n.ts';
import { rememberLocale } from '../i18n-en.ts';
import { brand } from '../state.ts';
import { errorMessage, field } from '../ui.ts';

export function renderAuth(root: HTMLElement, mode: 'login' | 'signup', onDone: () => void): void {
  const signup = mode === 'signup';
  const english = currentIntlLocale().startsWith('en');
  mount(
    root,
    publicPage(html`<main class="pma-auth">
      <section class="pma-auth__intro">
        <img class="pma-brand-logo pma-brand-logo--lg" src="${brand.logo}" alt="" width="64" height="64">
        <h1>${brand.name}</h1>
        <p>${t('Projekte, Risiken, Entscheidungen, Gates und Menschen an einem Ort – verknüpft, nachvollziehbar und offen für deine Werkzeuge.')}</p>
        <ul class="pma-auth__points">
          <li>${t('RAID-Register mit Risikomatrix und Entscheidungsprotokoll')}</li>
          <li>${t('Phasen und Freigabe-Gates mit messbaren Kriterien')}</li>
          <li>${t('API, signierte Webhooks und Audit-Log ab dem ersten Tag')}</li>
        </ul>
      </section>
      <section class="p-card pma-auth__card">
        <div class="p-card__body">
          <h2>${signup ? t('Arbeitsbereich anlegen') : t('Anmelden')}</h2>
          <form class="p-stack" data-p-gap="4" novalidate>
            ${signup ? field(t('Dein Name'), 'name', 'text', { required: true, attrs: 'autocomplete="name"' }) : ''}
            ${signup ? field(t('Organisation'), 'organizationName', 'text', { required: true, hint: t('Deine Firma oder dein Freelance-Name'), attrs: 'autocomplete="organization"' }) : ''}
            ${field(t('E-Mail'), 'email', 'email', { required: true, attrs: 'autocomplete="email"' })}
            ${field(t('Passwort'), 'password', 'password', {
              required: true,
              hint: signup ? t('Mindestens 10 Zeichen') : undefined,
              attrs: signup ? 'minlength="10" autocomplete="new-password"' : 'autocomplete="current-password"',
            })}
            <div class="p-alert p-alert--danger" role="alert" hidden data-error><span class="p-alert__icon" aria-hidden="true">!</span><div data-error-text></div></div>
            <button class="p-button p-button--primary" type="submit">${signup ? t('Konto erstellen') : t('Anmelden')}</button>
          </form>
          ${signup ? '' : html`<p class="pma-small pma-auth__switch"><a href="/reset">${t('Passwort vergessen?')}</a></p>`}
          <p class="pma-muted pma-auth__switch">${
            signup
              ? html`${t('Schon registriert?')} <a href="/login">${t('Anmelden')}</a>`
              : html`${t('Noch kein Konto?')} <a href="/signup">${t('Arbeitsbereich anlegen')}</a>`
          }</p>
          <p class="pma-small pma-auth__switch">${english
            ? html`<button type="button" class="p-button p-button--link" data-locale="de" lang="de">Deutsch</button>`
            : html`<button type="button" class="p-button p-button--link" data-locale="en" lang="en">English</button>`}</p>
        </div>
      </section>
    </main>`),
  );
  wireChrome(root);
  const form = root.querySelector('form')!;
  const errorBox = root.querySelector<HTMLElement>('[data-error]')!;
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const button = form.querySelector('button')!;
    button.disabled = true;
    errorBox.hidden = true;
    try {
      await api.post(signup ? '/auth/signup' : '/auth/login', signup ? { ...formData(form), locale: english ? 'en' : 'de' } : formData(form));
      onDone();
    } catch (error) {
      errorBox.querySelector('[data-error-text]')!.textContent = errorMessage(error);
      errorBox.hidden = false;
    } finally {
      button.disabled = false;
    }
  });
  root.querySelector<HTMLElement>('[data-locale]')?.addEventListener('click', (event) => {
    rememberLocale((event.currentTarget as HTMLElement).dataset.locale!);
    location.reload();
  });
  (form.querySelector('input') as HTMLInputElement).focus();
}
